<script setup lang="ts">
import Header from "~/components/layout/header.vue";
import Footer from "~/components/layout/footer.vue";
</script>

<template>
<div class="subpage-wrap">
  <Header :show-bread-crumb="true" />
  <div class="common-subpage-box" id="sub-content">
      <NuxtPage />
  </div>
  <Footer />
</div>
</template>

<style scoped>

</style>